"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typography = void 0;
exports.typography = {
    type: {
        primary: '"Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif'
    },
    weight: {
        regular: '300',
        medium: '400',
        bold: '600'
    },
    size: {
        regular: 16,
        medium: 20,
        large: 24,
        extraLarge: 80
    }
};
//# sourceMappingURL=typography.js.map